import { auth } from "../config/signup.config";
import { toastrError, toastrSuccess } from "../components/toastr";
import {
  signInWithPopup,
  signInWithCredential,
  GoogleAuthProvider,
} from "firebase/auth";
import { ref, push, get, getDatabase } from "firebase/database";
import { Capacitor } from "@capacitor/core";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";

async function processSignIn(user, navigate) {
  localStorage.setItem("email", user.email);
  localStorage.setItem("role", "admin");
  try {
    const database = getDatabase();
    const userRef = ref(database, "user");
    const snapshot = await get(userRef);
    let existingEmails = [];
    if (snapshot.exists()) {
      existingEmails = Object.values(snapshot.val());
    }
    const filteredEmail = existingEmails.filter((i) => i === user.email);
    if (!filteredEmail || filteredEmail.length === 0) {
      await createUser(user.email);
      localStorage.setItem("onboardingComplete", "false");
      navigate("/onboarding");
    } else {
      // Check if onboarding is complete
      const userInfoRef = ref(database, "userInfo");
      const infoSnapshot = await get(userInfoRef);
      let onboardingComplete = false;
      if (infoSnapshot.exists()) {
        const allUsers = Object.values(infoSnapshot.val());
        const currentUser = allUsers.find((u) => u.email === user.email);
        if (currentUser) {
          onboardingComplete = currentUser.onboardingComplete === true;
          if (currentUser.id) localStorage.setItem("ownerId", currentUser.id);
        }
      }
      localStorage.setItem("onboardingComplete", onboardingComplete ? "true" : "false");
      navigate(onboardingComplete ? "/dashboard" : "/onboarding");
    }
  } catch (err) {
    toastrError("Sign-in processing failed");
  }
}

const googleSignUp = async (navigate) => {
  try {
    if (Capacitor.isNativePlatform()) {
      await GoogleAuth.initialize({
        clientId: "47425390859-umvg9f2bn9nra0sm4qu6f8om392c2q2a.apps.googleusercontent.com",
        scopes: ["profile", "email"],
      });
      const googleUser = await GoogleAuth.signIn();
      const credential = GoogleAuthProvider.credential(
        googleUser.authentication.idToken
      );
      const result = await signInWithCredential(auth, credential);
      await processSignIn(result.user, navigate);
    } else {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      await processSignIn(result.user, navigate);
    }
  } catch (err) {
    toastrError(err);
  }
};

const googleSignOut = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      await GoogleAuth.initialize({
        clientId: "47425390859-umvg9f2bn9nra0sm4qu6f8om392c2q2a.apps.googleusercontent.com",
        scopes: ["profile", "email"],
      });
      await GoogleAuth.signOut();
    }
    await auth.signOut();
    localStorage.removeItem("onboardingComplete");
  } catch (err) {
    // ignore sign-out errors
  }
};

async function createUser(payload) {
  try {
    const database = getDatabase();
    const userRef = ref(database, "user");
    await push(userRef, payload);
    return true;
  } catch (err) {
    toastrError("Failed to create user");
    throw err;
  }
}

export { googleSignUp, googleSignOut, createUser };
